import type { ElementSchemaType } from '@vedalib/editor/lib/brand'
import type { ElementsTypes, ElementValue } from '@vedalib/editor/lib/elements'

import type { ElementState } from 'services/Store/Project/types'

import type { IElementConfig } from './elements.types'

export const genElementConfig = <
  T extends ElementsTypes = ElementsTypes,
  V extends ElementValue = ElementValue,
  S extends ElementSchemaType = ElementSchemaType,
  F extends ElementSchemaType = ElementSchemaType,
  FB extends ElementSchemaType = ElementSchemaType,
  St extends ElementState = ElementState,
>(
  config: Pick<IElementConfig<T, V, S, F, FB, St>, 'type' | 'defaultValue'>,
  customConfig: Omit<IElementConfig<T, V, S, F, FB, St>, 'type' | 'defaultValue'>,
) => ({ ...config, ...customConfig }) as IElementConfig<T>
